import { Table } from '@delmonicos/shared-design-system-react/src/components/table/table/table';
import { NoDataComponent } from '@delmonicos/shared-design-system-react/src/components/with-state-paginated-table/no-data';
import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { GatewayChargePointsInMaintenancePaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-points-in-maintenance-paginated.model';
import { useCallback } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

import { CHARGE_POINTS_COLUMN_LIST } from './charge-points.config';

interface ChargePointsComponentProps {
  chargePoints: GatewayChargePointsInMaintenancePaginatedModel;
}

export const ChargePointsComponent = ({
  chargePoints,
}: ChargePointsComponentProps): React.JSX.Element => {
  const navigate = useNavigate();

  const onRowClick = useCallback(
    (row: GatewayChargePointInMaintenanceModel) =>
      navigate(generatePath(APP_PATH.CHARGE_POINT.DETAILS, { id: row.id })),
    [navigate],
  );

  return (
    <Table<GatewayChargePointInMaintenanceModel>
      displayPagination={false}
      columns={CHARGE_POINTS_COLUMN_LIST}
      data={chargePoints.docs}
      noDataChildren={<NoDataComponent />}
      onRowClick={onRowClick}
    />
  );
};
